const API_URL = process.env.REACT_APP_API_URL;

export const sendMessageToAI = async (userMessage) => {
    try {
        const response = await fetch(`${API_URL}/api/chat`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userMessage }),
        });

        const data = await response.json();
        return data.reply;
    } catch (error) {
        console.error("API error:", error);
        return "Sorry, I couldn't process your request.";
    }
};
